import type { paths } from '@/types/api';
import { env } from '@/util/env';

type GetReferralByCodePath = paths['/v2/referrals/{code}']['get'];

type ReferralLookupPayload = GetReferralByCodePath['responses'][200]['content']['application/json'];

export type ReferralLookupResult = ReferralLookupPayload['data'];

export async function getReferralByCodeV2(code: string): Promise<ReferralLookupResult | null> {
  const normalizedCode = code.trim();

  if (!normalizedCode) {
    return null;
  }

  try {
    const response = await fetch(
      `${env.EXPO_PUBLIC_BASE_API_URL}/v2/referrals/${encodeURIComponent(normalizedCode)}`
    );

    if (!response.ok) {
      return null;
    }

    const payload = (await response.json()) as ReferralLookupPayload;

    if (!payload?.success || !payload?.data) {
      return null;
    }

    return payload.data;
  } catch {
    return null;
  }
}
